import { combineReducers } from 'redux'
import { RootStateBase } from "base/src/store/baseStore"
import { LoginReducer } from './login/reducers/loginReducers';
import { AuthPerfilReducer } from './perfil/reducers/perfilReducers';
import { RecuperarSenhaReducer } from './recuperarSenha/recuperarSenhaReducer';
import { ConfirmarSenhaReducer } from './confirmarSenha/reducers/confirmarSenhaReducers';

export const AuthReducerList = {
    LoginReducer,
    AuthPerfilReducer,
    RecuperarSenhaReducer,
    ConfirmarSenhaReducer
}
const AuthReducer = combineReducers(AuthReducerList);
  
export type RootStateAuth = RootStateBase & ReturnType<typeof AuthReducer>;

